export default __webpack_public_path__ + "static/media/rate.931c8bab.svg";